import { useState } from "react";
import { flushSync } from "react-dom";
import { message } from "antd";

// Preview one record; mount the full selection in small chunks when printing.
export default function useBulkPrintPreview(items) {
  const [previewPage, setPreviewPage] = useState(1);
  const [printCount, setPrintCount] = useState(0);
  const [isPrinting, setIsPrinting] = useState(false);
  const page = Math.min(previewPage, Math.max(items.length, 1));

  const finishPrint = () => {
    setPrintCount(0);
    setIsPrinting(false);
  };

  const onBeforePrint = async () => {
    setIsPrinting(true);
    for (let count = 5; count < items.length + 5; count += 5) {
      flushSync(() => setPrintCount(Math.min(count, items.length)));
      await new Promise((resolve) => setTimeout(resolve, 0));
    }
  };

  return {
    previewPage: page,
    setPreviewPage,
    isPrinting,
    visibleItems: printCount ? items.slice(0, printCount) : items.slice(page - 1, page),
    printOptions: {
      onBeforePrint,
      onAfterPrint: finishPrint,
      onPrintError: () => {
        finishPrint();
        message.error("Impossible de préparer l'impression.");
      },
    },
  };
}
